import React, {Component, createRef} from "react";
import DataTable from './TableBase';
import {withRouter} from "react-router-dom";
import {apiCall} from "../../helpers/MainHelper";
import withPermissions from "../WithPermissions";

class StockMovementsTable extends Component{

    constructor(props) {
        super(props);
        this.tableRef = createRef();
    }

    triggerFetch = (page = 1, size = 10, search = '') => {
        if (this.tableRef.current) {
            this.tableRef.current.fetchData(page, size, search);
        }
    };

    handleMovementDetail = (movementId) => {
        this.props.history.push(`/stock/movement-detail/${movementId}`);
    }

    getMovementTypeLabel = (type) => {
        const types = {
            'purchase': 'Satın Alma',
            'sale': 'Satış',
            'transfer_in': 'Transfer Giriş',
            'transfer_out': 'Transfer Çıkış',
            'adjustment': 'Düzeltme',
            'return': 'İade'
        };
        return types[type] || type;
    }

    getMovementTypeBadge = (type) => {
        const badges = {
            'purchase': 'badge-success',
            'sale': 'badge-danger',
            'transfer_in': 'badge-info',
            'transfer_out': 'badge-warning',
            'adjustment': 'badge-secondary',
            'return': 'badge-primary'
        };
        return badges[type] || 'badge-secondary';
    }

    render() {
        const {userPermissions} = this.props;
        const userHasViewPermission = userPermissions.includes('stock.view');

        const columns = [
            {
                name:'Depo',
                selector:row => row.warehouse ? row.warehouse.name : '-',
                sortable:true,
                grow: 1,
                wrap: true,
                style: {
                    padding: '12px 8px'
                }
            },
            {
                name:'Stok Kalemi',
                selector:row => row.stock_item ? row.stock_item.name : '-',
                sortable:true,
                grow: 2,
                wrap: true,
                cell: row => (
                    <div style={{fontWeight: '500', color: '#212529', padding: '12px 8px'}}>
                        {row.stock_item ? row.stock_item.name : '-'}
                        {row.stock_item?.sku && (
                            <div style={{fontSize: '11px', color: '#6c757d', fontFamily: 'monospace', marginTop: '4px'}}>
                                {row.stock_item.sku}
                            </div>
                        )}
                    </div>
                )
            },
            {
                name:'Hareket Tipi',
                cell: row => (
                    <span className={`badge ${this.getMovementTypeBadge(row.movement_type)}`} style={{
                        fontSize: '11px',
                        padding: '8px 14px',
                        fontWeight: '600',
                        minWidth: '110px',
                        textAlign: 'center',
                        display: 'inline-block'
                    }}>
                        {this.getMovementTypeLabel(row.movement_type)}
                    </span>
                ),
                sortable:true,
                minWidth: '150px',
                maxWidth: '170px',
                center: true,
                style: {
                    padding: '12px 8px'
                }
            },
            {
                name:'Miktar',
                selector:row => row.quantity,
                sortable:true,
                minWidth: '110px',
                maxWidth: '130px',
                center: true,
                cell: row => (
                    <div style={{
                        fontWeight: '700',
                        fontSize: '17px',
                        color: ['purchase', 'transfer_in', 'return'].includes(row.movement_type) ? '#28a745' : '#dc3545',
                        padding: '12px 8px'
                    }}>
                        {['purchase', 'transfer_in', 'return'].includes(row.movement_type) ? '+' : '-'}
                        {Math.round(parseFloat(row.quantity || 0))}
                    </div>
                )
            },
            {
                name:'Tarih',
                selector:row => new Date(row.movement_date).toLocaleDateString('tr-TR'),
                sortable:true,
                minWidth: '120px',
                maxWidth: '140px',
                center: true,
                style: {
                    padding: '12px 8px'
                }
            },
            {
                name:'Kullanıcı',
                selector:row => row.user ? row.user.name : '-',
                sortable:true,
                grow: 0.8,
                wrap: true,
                style: {
                    padding: '12px 8px'
                }
            },

        ];

        return (
            <DataTable
                ref={this.tableRef}
                columns={columns}
                onRowClicked={userHasViewPermission ? row => this.handleMovementDetail(row.id) : undefined}
                dataEndpoint="business/stock/movement/all"
            />
        );
    }
}

export default withPermissions(withRouter(StockMovementsTable));
